import ComponentWithSocket from '../../lib/component';
import { Component } from 'vue-property-decorator';

import template from './verify-pending.vue';
import { ActionPayload } from 'vuex';

import * as Store from './../../store';

@Component({
    mixins: [template],
})
export default class VerifyPending extends ComponentWithSocket {
    constructor() {
        super();
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    mounted() {
        Store.commitLoaderVisibility(this.$store, false);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/verify-pending/index.ts